import React from 'react';
import FuelEmptyIcon from './img/fuelConfig.svg';
import Text from '../text/Text';
import './tableemptystate.css';

const FuelConfiguratorTableEmptyState = () => (
    <div className="empty-state-container">
        <img loading="lazy" src={FuelEmptyIcon} alt="" style={{ margin: 'auto' }} />
        <div className="empty-state-text">
            <Text text="No Fuel Configurator Policies" size="1.25rem" weight="600" align="center" height="auto" lineHeight="30px" />
            <Text text="Your search did not match any fuel configurator policies. Newly added fuel configurator policies will appear momentarily" size="1rem" weight="400" align="center" color="#475467" height="auto" lineHeight="24px" />
        </div>
    </div>
);

export default FuelConfiguratorTableEmptyState;
